import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { frFR } from "@mui/x-date-pickers/locales";
import { fr } from "date-fns/locale";
import React from "react";

const DatePickerProvider = ({ children }: { children?: React.ReactNode }) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={fr}
      localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      {children}
    </LocalizationProvider>
  );
};

export default DatePickerProvider;
